import React, {useState} from "react";
import DictStatisticsTable from "./DictStatisticsTable/DictStatisticsTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../../utils/utils";
import { useTranslation } from "react-i18next";

function DictStatisticsCard(props) {
    const { t } = useTranslation()

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);

    const {dict_statistics} = props
    let initialExpand = dict_statistics.flag !== "positive"
    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }
    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    {t("dict_statistics")}
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(dict_statistics.flag)}
                </div>
                {dict_statistics.dict_statistics_available === true ?
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>
                : null}
            </div>
            <div className={["normalText", "normalMediumSize"].join(" ")} style={{margin:"4px 0px"}}>
                {dict_statistics.description}
            </div>
            {dict_statistics.dict_statistics_available === true ?
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <DictStatisticsTable dict_statistics={dict_statistics}/>
                </div>
            </Collapse>
            : null}
        </div>
        );
}

export default DictStatisticsCard
